/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Counts_Zero_NoneInputs */



/**
* | output |
* | --- |
* | "none of them price to €0.00" |
*
* @param {Partner_Billing_Board_Counts_Zero_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_counts_zero_none = /** @type {((inputs?: Partner_Billing_Board_Counts_Zero_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Counts_Zero_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("keiner davon ergibt 0,00 €")
	return /** @type {LocalizedString} */ ("none of them price to €0.00")
});